import Swiper from 'swiper/bundle';
import idx from '../helpers/idx';

export default () => {
	const popup = document.querySelector('.gallery');

	if (!popup) {return}
	
	const sliderPrefix = 'gallery__';
	const sliderEl = document.querySelector(`.${sliderPrefix}slider`);
	const tabsEl = document.querySelector(`.${sliderPrefix}tabs`);
	const buttons = document.querySelectorAll('.gallery__thumb');
	const btnClose = document.querySelector('.js-close-gallery');
	const body = document.body;
	const images = popup.querySelectorAll('img[data-src]');

	const SLIDE_SPEED = 800;
	const BTN_ACTIVE = 'contact__btn--active';


	const openButtons = document.querySelectorAll('.product-main__slide');

	if (sliderEl) {
		const slider = new Swiper(sliderEl, {
			wrapperClass: `${sliderPrefix}slider-wrapper`,
			slideClass: `${sliderPrefix}slide`,
			slideActiveClass: `${sliderPrefix}slide--active`,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			loop: true,

			speed: SLIDE_SPEED,
		});

		buttons.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				let index = idx(btn);
				slider.slideToLoop(index);
			});
		});

		if (openButtons.length) {
			openButtons.forEach(function(btn) {
				btn.addEventListener('click', (e) => {
					let index = idx(btn);

					slider.slideToLoop(index);
					popup.classList.add('gallery--visible');
					body.classList.add('is-popup-opened');
					loadImages(images);
				});

				btn.addEventListener('mouseenter', (e) => {
					setTimeout(function(){
						loadImages(images);
					}, 300);
				});
			});
		}

		if (btnClose && popup) {
			btnClose.addEventListener('click', (e) => {
				e.preventDefault();

				popup.classList.remove('gallery--visible');
				body.classList.remove('is-popup-opened');
			});
		}
	}


	function loadImages(images) {
		images.forEach(function(image) {
			if (!image.classList.contains('loaded')) {
				image.src = image.dataset.src;
				image.classList.add('loaded');
			}
		});
	}
}